var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"aup-base-eye-toggle",on:{"click":function($event){_vm.local_value = !_vm.local_value}}},[(_vm.local_value)?_c('IconEyeVisible'):_c('IconEyeHidden')],1)}
var staticRenderFns = []

export { render, staticRenderFns }